(function() {
'use strict';

function EventEmitter() {
    this._listeners = {};
}
var proto = EventEmitter.prototype;
proto.on = function(event, listener) {
    if (!this._listeners[event]) {
        this._listeners[event] = [];
    }
    this._listeners[event].push(listener);
};
proto.removeAllListeners = function() {
    this._listeners = {};
};
proto.off = function(event, listener) {
    if (!this._listeners[event]) {
        return;
    }
    this._listeners[event] = this._listeners[event].filter(function(fn) {
        return fn !== listener;
    });
};
proto.emit = function(event, data) {
    var me = this,
        listenersCopy = _.clone(me._listeners[event] || []);
    if (me._listeners['*']) {
        listenersCopy = listenersCopy.concat(me._listeners['*']);
    }
    listenersCopy.forEach(function(fn) {
        try {
            fn.call(me.currentContext, data);
        } catch(err) {
            console.log(err);
        }
    });
};

window.EventEmitter = EventEmitter;
}());
